import { privateAxios } from "../lib/api";
import { MyLimit, MyTransactions } from "../types/buy-now-paylater";
import { ApiConstants } from "../utils/constants";

export class BuyNowPaylaterService {
  static async getMyLimit(): Promise<MyLimit> {
    const response = await privateAxios.get(`${ApiConstants.MyLimit}/my-limit`);
    return response.data;
  }

  static async getTransactions({
    paging = false,
    limit = 10,
    offset = 0,
    timePeriod,
    sortBy = "id",
    sort = "desc",
  }: {
    paging?: boolean;
    limit?: number;
    offset?: number;
    timePeriod?: string | null;
    sortBy?: string;
    sort?: "asc" | "desc";
  }): Promise<MyTransactions> {
    const response = await privateAxios.get(
      `${ApiConstants.MyLimit}/transactions`,
      {
        params: {
          paging,
          limit,
          offset,
          timePeriod,
          sortBy,
          sort,
        },
      }
    );
    return response.data;
  }
}
